import { motion } from "framer-motion";
import { Briefcase, Users } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { FiLoader } from "react-icons/fi";
import { IoMdSend } from "react-icons/io";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import csv from "../../assets/csv ss.png";
import existing from "../../assets/existing.webp";
import fresher from "../../assets/fresher.webp";
import ModelPopUp from "../../components/ModelPopUp";
import { useNotification } from "../../contextApi/NotificationProvider";
import { getAssessment } from "../../redux/ReduxSlices/assessmentSlice";
import {
    getUserDetails,
} from "../../redux/ReduxSlices/authSlice";
import {
    addIndividual,
    getOpenPosition,
    getPosition
} from "../../redux/ReduxSlices/candidateSlice";
import AssessmentRedirectPopup from "./AssessmentRedirectPopup";

const IndividualAssessment = () => {
    const inputRef = useRef(null);
    const fileInputRef = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [selectedCard, setSelectedCard] = useState(null);
    const [selectedTest, setSelectedTest] = useState(null);
    const [activeDescription, setActiveDescription] = useState(null);
    const [position, setposition] = useState("");
    const [userEmail, setUserEmail] = useState("");
    const [emailList, setEmailList] = useState([]);
    const [emailError, setEmailError] = useState("");
    const { showNotification } = useNotification();
    const [assessmentsData, setAssessmentsData] = useState([]);
    const { positions } = useSelector((state) => state.candidate);
    const getOpenPositionData = useSelector((state) => state.candidate);
    const [showDropdown, setShowDropdown] = useState(false);
    const [filteredPositions, setFilteredPositions] = useState([]);
    const wrapperRef = useRef(null);
    const companyRef = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const [assessmentValue, setAssessmentValue] = useState(null);
    const [loading, setLoading] = useState(false);
    const [company, setCompany] = useState("");
    const [companyId, setCompanyId] = useState("");
    const [companyPosition, setCompanyPosition] = useState("");
    const [showCompDropdown, setShowCompDropdown] = useState(false);
    const [filterCompany, setFilterCompany] = useState(false);
    const [selectedType, setSelectedType] = useState("own"); // new state
    const { userData } = useSelector((state) => state.auth);
    const [showPopup, setShowPopup] = useState(false)
    const [currentStep, setCurrentStep] = useState(1);
    const [totalSteps, setTotalSteps] = useState(3)
    const [redirectUrl, setRedirectUrl] = useState("")

    const {
        register,
        handleSubmit,
        watch,
        reset,
        trigger,
        formState: { errors, isValid },
    } = useForm({
        mode: "onChange",
    });


    const handleOpenPopup = () => setShowPopup(true)
    const handleClosePopup = () => setShowPopup(false)

    // const handleConfirm = () => {
    //     navigate('/student-report')
    //     handleClosePopup()
    // }


    const getAllAssessments = async () => {
        try {
            const response = await dispatch(getAssessment()).unwrap();
            setAssessmentsData(response.assessments);
        } catch (error) {
            console.log("err", error);
        }
    };

    useEffect(() => {
        if (
            (selectedCard === "new" || selectedCard === "existing") &&
            assessmentsData.length > 0
        ) {
            const first = assessmentsData[0];
            setSelectedTest(first.assessment_pk);
            setAssessmentValue(first);
            setActiveDescription(0); // Show first description by default
        }
    }, [selectedCard, assessmentsData]);

    useEffect(() => {
        getAllAssessments();
    }, []);

    const handleKeyDown = (e) => {

        if (e.key === "Enter" || e.key === ",") {
            e.preventDefault();
            const trimmed = userEmail.trim();
            if (validateEmail(trimmed) && !emailList.includes(trimmed)) {
                setEmailList([...emailList, trimmed]);

                setUserEmail("");
                setEmailError("");
            } else {
                setEmailError("Please enter a valid or unique email.");
            }
        }
    };

    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handleCSVUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            const content = e.target.result;
            const lines = content.split(/\r?\n/);
            const emails = [];

            lines.forEach((line) => {
                const email = line.trim().replace(/['"]+/g, "");
                if (validateEmail(email)) {
                    emails.push(email);
                }
            });

            const uniqueEmails = [...new Set([...emailList, ...emails])];
            setEmailList(uniqueEmails);
        };
        reader.readAsText(file);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (companyRef.current && !companyRef.current.contains(event.target)) {
                setShowCompDropdown(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [companyRef]);

    useEffect(() => {
        dispatch(getPosition());
        dispatch(getOpenPosition());
        // Get user Credits
        dispatch(getUserDetails());
    }, [dispatch]);

    // Get user Credits
    const creditPoint = userData?.company_info?.credit_point;

    const handleFetchPositions = async () => {
        // Check for null, empty array, or array with empty string
        const isInvalid =
            positions === null ||
            (Array.isArray(positions) && (positions.length === 0 || positions.every(p => p.trim() === '')));

        if (isInvalid) {
            setShowDropdown(false);
            return;
        }
        dispatch(getPosition());
        setShowDropdown(true);
    };

    useEffect(() => {
        if (positions && positions.length > 0) {
            setFilteredPositions(positions);
        }
    }, [positions]);

    const handleFetchCompany = async () => {
        if (positions.length === 0) {
            await dispatch(getPosition());
        }
        const cleaned = positions.filter((pos) => pos.trim() !== "");
        setFilteredPositions(cleaned);
        setShowCompDropdown(true);
        setShowCompDropdown(true);
    };

    const handlePositionChange = (e) => {
        const input = e.target.value;
        setCompanyPosition(input);
        setCompany("");

        const filtered = positions.filter((pos) =>
            pos.toLowerCase().includes(input.toLowerCase())
        );

        setFilteredPositions(filtered);
    };

    const handleSelectPosition = (pos) => {
        setposition(pos);
        setShowDropdown(false);
    };

    const handleSelectCompany = (comp) => {
        setCompanyPosition(comp.company_position);
        setCompany(comp.company_name);
        setCompanyId(comp.company_id);
        setShowCompDropdown(false);
    };

    useEffect(() => {
        if (position.positions && positions.positions.length > 0) {
            const filtered = positions.positions.filter((pos) =>
                pos.toLowerCase().includes(position.toLowerCase())
            );
            setFilteredPositions(filtered);
        } else if (
            getOpenPositionData.getOpenPositionData &&
            getOpenPositionData.getOpenPositionData.length > 0
        ) {
            const filteredComp = getOpenPositionData.getOpenPositionData.filter(
                (c) => c.company_name
            );
            setFilterCompany(filteredComp);
        } else {
            setFilteredPositions(positions.positions);
            setFilterCompany(getOpenPositionData.getOpenPositionData);
        }
    }, [
        position,
        positions.positions,
        getOpenPositionData,
        getOpenPositionData.getOpenPositionData,
    ]);

    const submit = async () => {
        // e.preventDefault();
        const trimmedPosition = position.trim();
        const trimmedCompanyPosition = companyPosition.trim();

        // if (selectedCard !== "existing") {
        //     if (selectedType === "own" && !trimmedPosition) {
        //         return showNotification(
        //             "Please enter the Position Name",
        //             "warning",
        //             3000
        //         );
        //     }

        //     if (selectedType === "vendor" && !trimmedCompanyPosition) {
        //         return showNotification(
        //             "Please Select the Company Position from dropdown",
        //             "warning",
        //             3000
        //         );
        //     }
        // }

        setLoading(true);

        const emailListLength = emailList.length;

        const hasEnoughCredits = creditPoint > 0;

        if (!hasEnoughCredits) {
            showNotification(
                "Insufficient credits. Please purchase more to continue",
                "error",
                2500
            );
            navigate("/pricing")
            setLoading(false);
            return;
        }

        const basePayload = {
            assessment_id: selectedTest,
            emails: [userData.user_info.email],
            company_id: companyId,
            is_for_another_company: false,
            is_new_joiner: selectedCard === "new",
            is_existing_emp: selectedCard === "existing",
            prefered_industry: watch("preferedIndustry")
        };

        const payload = {
            ...basePayload,
            ...(selectedCard === "new" &&
                selectedType === "own" && { position_title: watch("jobTitle") }),
        };

        try {
            const res = await dispatch(addIndividual(payload)).unwrap();
            console.log("res", res)

            dispatch(getUserDetails());

            if (res?.success) {
                setRedirectUrl(res?.data[0]?.assessment_url)
                // showNotification("Assessment Sent Successfully!", "success", 3000);

                handleOpenPopup();
                setUserEmail("");
                setEmailList([]);
                setposition("");
                // setSelectedTest(null);
                setLoading(false);
                setCompany("");
                setCompanyPosition("");
            } else {
                showNotification(
                    res?.message || "Something went wrong",
                    "error",
                    3000
                );

                if (res.payload?.message === "Don't have sufficient credits.") {
                    setTimeout(() => {
                        navigate("/pricing");
                    }, 2500);
                }
            }
        } catch (err) {
            setLoading(false);
            console.log("eeeee", err)
            showNotification("An unexpected error occurred", "error", 3000);
        } finally {
            setLoading(false);
        }
    };

    const handleFormNextStep = (e) => {
        e.preventDefault();
        const trimmedPosition = position.trim();
        const trimmedCompanyPosition = companyPosition.trim();

        if (selectedCard !== "existing") {
            if (selectedType === "own" && !trimmedPosition) {
                return showNotification(
                    "Please enter the Position Name",
                    "warning",
                    3000
                );
            }

            if (selectedType === "vendor" && !trimmedCompanyPosition) {
                return showNotification(
                    "Please Select the Company Position from dropdown",
                    "warning",
                    3000
                );
            }
        }
        setCurrentStep((p) => p + 1);
    }

    const cards = [
        {
            id: "new",
            title: "Fresh Graduate",
            description: "Launch assessment for freshers",
            icon: <Briefcase className="w-8 h-8 text-white" />,
            gradient: "from-blue-600 via-purple-500 to-pink-600",
            img: fresher
        },
        {
            id: "existing",
            title: "Working Professional",
            description: "Evaluate experienced employees' performance and growth",
            icon: <Users className="w-8 h-8 text-white" />,
            gradient: "from-green-600 via-teal-500 to-cyan-600",
            img: existing
        },
    ];
    return (
        <div className="w-full min-h-screen bg-gradient-to-br from-white to-gray-50 p-4 max-md:p-0 max-md:pt-8 md:p-6 flex flex-col items-center  overflow-y-auto">
            {loading && (
                <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30">
                    <FiLoader className="animate-spin text-[#822bda] text-4xl" />
                </div>
            )}

            <div className="flex flex-col items-center justify-center h-[80vh] max-md:mt-8">
                <motion.div
                    className="max-w-xl w-full mx-auto mb-2 md:mb-10 text-center px-4 mt-14 sm:mt-0 md:mt-16"
                    initial={{ opacity: 0, y: -50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                >
                    <h1 className="text-2xl sm:text-2xl md:text-4xl font-extrabold text-gray-800 mb-4 sm:mb-6">
                        Begin Your Evaluation
                    </h1>
                    <p className="text-gray-600 text-sm sm:text-base md:text-lg max-md:mb-4">
                        Follow these simple steps to Start your assessments.
                    </p>
                </motion.div>

                <motion.div
                    className="max-md:max-w-sm mx-auto py-6 px-4 bg-white rounded-lg shadow-md w-[600px] h-auto"
                    style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)' }}
                    initial={{ opacity: 0, scale: 0.5 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.7, ease: "backOut" }}
                >
                    {/* Progress bar with steps indicator */}
                    <div className="mb-6 flex items-center justify-between">
                        <div className="flex justify-center items-center mb-2">
                            <h1 className="text-xl max-md:text-xl font-bold text-gray-800">{currentStep == 1 ? "Choose Assessment Type" : currentStep == 2 ? "Launch Assessment" : (currentStep == 3 && selectedCard == "existing") ? "Review & Send" : ""}</h1>
                        </div>
                        <span className="text-sm font-medium text-gray-700 bg-gray-200 px-2 rounded-md">Step {currentStep} of {totalSteps}</span>
                        {/* <div className="w-full bg-gray-200 rounded-full h-2">
                      <div
                        className="bg-violet-600 h-2 rounded-full"
                        style={{ width: `${(currentStep / totalSteps) * 100}%` }}
                      ></div>
                    </div> */}
                    </div>
                    {currentStep === 1 && (
                        <>
                            {cards.map((card) => {
                                const isManager = localStorage.getItem("userType") === "manager";
                                const isDisabled = isManager && card.id === "new";
                                const isSelected = selectedCard === card.id;

                                return (
                                    <motion.div
                                        key={card.id}
                                        whileHover={!isDisabled ? { scale: 1.02 } : {}}
                                        className={`relative mb-6 p-4 rounded-lg border-2 transition-all duration-200
                                                ${isDisabled
                                                ? "bg-gray-100 cursor-not-allowed border-gray-200"
                                                : isSelected
                                                    ? "bg-violet-50 border-violet-600 cursor-pointer shadow-sm"
                                                    : "bg-white border-gray-200 cursor-pointer hover:bg-gray-50"
                                            }`}
                                        onClick={() => {
                                            if (isDisabled) return;
                                            setSelectedCard(card.id);
                                            setSelectedTest(null);
                                            setUserEmail("");
                                            setposition("");
                                            setEmailList([]);
                                        }}
                                    >
                                        <div
                                            className={`absolute inset-0  bg-gradient-to-br ${card.gradient
                                                }
                                                ${isDisabled ? "opacity-10" : "opacity-20"
                                                } pointer-events-none`}
                                        />
                                        <div className="flex gap-2 justify-center items-center h-full">
                                            {/* <div className={`p-2 rounded-full ${isDisabled
                                                ? "bg-gray-300"
                                                : isSelected
                                                    ? "bg-violet-100"
                                                    : "bg-gray-100"
                                                }`}>
                                                {React.cloneElement(card.icon, {
                                                    className: isDisabled
                                                        ? "text-gray-500"
                                                        : isSelected
                                                            ? "text-violet-600"
                                                            : "text-gray-600",
                                                })}
                                            </div> */}
                                            <div>
                                                <img className="w-10 h-10 p-8 max-md:p-0 sm:w-28 sm:h-28 object-contain rounded-md" src={card.img} />
                                            </div>
                                            <div className="flex flex-col flex-1">
                                                <div className="flex items-center gap-3 mb-2">
                                                    <h2 className={`text-xl font-bold ${isDisabled
                                                        ? "text-black"
                                                        : isSelected
                                                            ? "text-black"
                                                            : "text-black"
                                                        }`}>
                                                        {card.title}
                                                    </h2>
                                                </div>
                                                <p className={`mb-3 ${isDisabled
                                                    ? "text-black"
                                                    : isSelected
                                                        ? "text-black"
                                                        : "text-black"
                                                    } text-sm`}>
                                                    {card.description}
                                                    {isDisabled && (
                                                        <span className="block text-sm text-red-600 mt-1">
                                                            Only accessible to Site Manager or Site Admin users.
                                                        </span>
                                                    )}
                                                </p>
                                            </div>
                                            <MdOutlineKeyboardArrowRight
                                                size={24}
                                                className={
                                                    isDisabled
                                                        ? "text-gray-400"
                                                        : isSelected
                                                            ? "text-violet-500"
                                                            : "text-gray-400"
                                                }
                                            />
                                        </div>
                                    </motion.div>
                                );
                            })}
                            <motion.button
                                whileHover={{ scale: 1.02 }}
                                whileTap={{ scale: 0.98 }}
                                disabled={!selectedCard}
                                className={`w-full py-2 px-4 text-white font-medium rounded-lg transition duration-200 ${selectedCard
                                    ? "btn-gradient"
                                    : "bg-gray-400 cursor-not-allowed"
                                    }`}
                                onClick={() => {
                                    if (selectedCard) {
                                        setCurrentStep((p) => p + 1);
                                    }
                                }}
                            >
                                Next →
                            </motion.button>
                        </>
                    )}
                    {currentStep == 2 && (
                        <div className="w-full max-w-2xl mx-auto mt-8 px-4 max-md:px-2">
                            <motion.div
                                initial={{ opacity: 0, scale: 0.98 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.3 }}
                            >
                                <form className="space-y-2" onSubmit={handleFormNextStep}>
                                    {/* Email Input Section */}
                                    <div>
                                        {selectedCard === "existing" ?
                                            <p className="font-semibold  text-gray-600">Begin your assessment as an experienced candidate — simply click on next to proceed</p>
                                            :
                                            <p className="font-semibold text-sm text-gray-600">What position are you interested in? Please enter it below <span className="text-gray-600 font-normal">(ex: Sales Executive, Junior Software Engineer) </span> </p>
                                        }
                                        {/* <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Enter email addresses
                                        </label>
                                        <div
                                            onClick={() => inputRef.current?.focus()}
                                            className="flex flex-wrap items-start gap-2 p-1 border border-gray-300 rounded-lg focus-within:ring-2 focus-within:ring-violet-500 focus-within:border-transparent  overflow-y-auto custom-scrollbar bg-white"
                                        >
                                            <input
                                                ref={inputRef}
                                                type="text"
                                                value={userEmail}
                                                onChange={(e) => setUserEmail(e.target.value)}
                                                onKeyDown={handleKeyDown}
                                                placeholder="Type email, then press Enter"
                                                className="flex-1  outline-none text-sm px-2 py-1 bg-transparent"
                                            />
                                        </div> */}
                                        {/* <div className="flex gap-1 flex-wrap overflow-y-auto max-h-[6.5rem] mt-2">
                                            {emailList.map((email, index) => (
                                                <div
                                                    key={index}
                                                    className="flex items-center bg-violet-100 text-violet-800 px-3 py-1 rounded-full text-sm mt-2"
                                                >
                                                    {email}
                                                    <button
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setEmailList(emailList.filter((e) => e !== email));
                                                        }}
                                                        className="ml-2 text-violet-500 hover:text-violet-800 text-sm"
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                        {emailError && (
                                            <p className="text-red-500 text-sm mt-1">{emailError}</p>
                                        )} */}
                                    </div>

                                    {/* Position Input (for new hires) */}
                                    {selectedCard === "new" && selectedType === "own" && (
                                        <div className="relative w-full" ref={wrapperRef}>
                                            <label className="block text-sm font-medium text-gray-700 mb-2 max-md:mt-4 mt-4">
                                                Enter Position Name
                                            </label>
                                            <input
                                                type="text"
                                                value={position}
                                                onClick={handleFetchPositions}
                                                onChange={(e) => setposition(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        e.preventDefault(); // Prevent form submit
                                                    }
                                                }}
                                                placeholder="e.g. Software Engineer"
                                                className="w-full border border-gray-300 rounded-lg px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent transition bg-white"
                                            />
                                            {showDropdown && Array.isArray(positions) && positions.length > 0 && (
                                                <ul className="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto text-sm transition-all duration-200 ease-in-out">
                                                    {positions.map((pos, index) => (
                                                        <li
                                                            key={index}
                                                            className="px-4 py-2 hover:bg-violet-100 cursor-pointer transition-colors"
                                                            onClick={() => handleSelectPosition(pos)}
                                                        >
                                                            {pos}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    )}

                                    {/* Email Count & Submit Button */}
                                    <div className="flex items-center justify-between pt-4">
                                        <button className="px-6 py-2 rounded-md text-sm font-medium transition bg-gray-300 text-gray-600"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (selectedCard) {
                                                    setCurrentStep((p) => p - 1);
                                                }
                                            }}
                                        >Back</button>
                                        <button
                                            type="submit"
                                            // disabled={emailList.length === 0 || loading}
                                            className={`px-6 py-2 rounded-md text-sm font-medium transition btn-gradient`}
                                        >
                                            Next →
                                        </button>
                                    </div>
                                </form>
                            </motion.div>

                            <ModelPopUp
                                show={showModal}
                                onClose={() => setShowModal(false)}
                                title="Upload Email's Via CSV Format Guide"
                                description={
                                    <>
                                        <p className="text-sm mb-2">
                                            Please follow the updated CSV format to ensure smooth processing:
                                        </p>
                                        <ul className="list-disc list-inside text-sm text-gray-600 text-start">
                                            <li><strong>Headers:</strong> <code>email</code></li>
                                            <li><strong>Example row:</strong> johndoe@example.com</li>
                                            <li>Ensure all email addresses are valid and properly formatted.</li>
                                            <li>Do not include empty rows or extra columns.</li>
                                            <li>Go back and click on <strong>'Download Sample CSV'</strong>. It will save a CSV file to your device. Then, open the file and add your list of emails to it.</li>
                                        </ul>
                                        <p className="text-sm text-start text-gray-700 mt-3">
                                            This CSV will be used to send personalized emails.
                                            Please review the data carefully before uploading.
                                        </p>
                                    </>
                                }
                                imageUrl={csv}
                            />
                        </div>
                    )}

                    {/* relative rounded-2xl md:rounded-3xl px-4 py-3 md:px-6 md:py-4
                    bg-white/10 cursor-pointer
                    backdrop-blur-lg border border-white/30 shadow-lg hover:shadow-xl transition-all duration-300 w-full */}


                    {/* {(currentStep === 3 && selectedCard == "existing") && (
                        <div className="w-full max-w-2xl mx-auto mt-1 px-4 max-md:px-4">
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3 }}
                                className="mb-8 text-center"
                            >
                                <p className="text-gray-600">
                                    Adding a reporting manager allows them to view the assessment results for this candidate or employee. This step is optional.
                                </p>
                            </motion.div>

                            <motion.div
                                initial={{ opacity: 0, scale: 0.98 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.3 }}
                            >
                                <form className="space-y-6" onSubmit={handleFormNextStep}>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Reporting Manager's Email(s)
                                        </label>

                                        <div
                                            className="flex gap-1 flex-wrap overflow-y-auto max-h-[6.5rem] mt-2"
                                        >
                                            
                                        </div>
                                    </div>
                                    <div className="w-full">
                                        <button className={`w-full px-6 py-2 rounded-md text-sm font-medium transition bg-violet-600 text-white hover:bg-violet-700`}
                                            onClick={(e) => {
                                                e.preventDefault()
                                            }}>
                                            Add Reporting Manager
                                        </button>
                                    </div>
                                    <div className="text-center font-bold py-4">
                                        You can skip this step if you don't want to add a reporting manager.
                                    </div>

                                    <div className="flex items-center justify-between pt-4">
                                        <button
                                            className="px-6 py-2 rounded-md text-sm font-medium transition bg-gray-200 text-gray-700 hover:bg-gray-300"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setCurrentStep((p) => p - 1);
                                            }}
                                        >
                                            Back
                                        </button>

                                        <div className="flex gap-4">
                                            <button
                                                type="submit"
                                                className={`px-6 py-2 rounded-md text-sm font-medium transition bg-violet-600 text-white hover:bg-violet-700`}
                                            >
                                                Next →
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </motion.div>
                        </div>
                    )} */}
                    {currentStep === 3 && (
                        <div className="w-full max-w-2xl mx-auto mt-8 px-4 max-md:px-2">
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3 }}
                                className="mb-8 text-center"
                            >

                            </motion.div>

                            <motion.div
                                initial={{ opacity: 0, scale: 0.98 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.3 }}
                                className="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
                            >
                                {/* Summary Section */}
                                <div className="mb-6">
                                    <h3 className="text-lg font-bold text-gray-800 mb-4">Summary</h3>

                                    <div className="grid grid-cols-2 gap-4 mb-4">
                                        <div>
                                            <p className="text-sm text-gray-500">Assessment Type</p>
                                            <p className="font-medium text-gray-800">
                                                {selectedCard === 'new' ? 'New Hire Assessment' : 'Existing Employee Assessment'}
                                            </p>
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-500">Recipients</p>
                                            <p className="font-medium text-gray-800">1</p>
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-2 gap-4">
                                        <div>
                                            <p className="text-sm text-gray-500">Credits Required</p>
                                            <p className="font-medium text-gray-800">1</p>
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-500">Available Credits</p>
                                            <p className="font-medium text-gray-800">{userData.company_info.credit_point} {userData.company_info.credit_point == 1 ? "Credit" : "Credits"}</p>
                                        </div>
                                    </div>
                                </div>

                                {/* Recipient List Section */}
                                <div className="mb-6">
                                    <div className="flex items-center gap-2 mb-3">
                                        <svg className="w-5 h-5 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                                        </svg>
                                        <h4 className="text-sm font-medium text-gray-700">
                                            Recipient ({userData.user_info.email})
                                        </h4>
                                    </div>

                                    <div className="border border-gray-200 rounded-lg overflow-hidden cursor-not-allowed">
                                        <div className="max-h-48 overflow-y-auto">
                                            {emailList.map((email, index) => (
                                                <div
                                                    key={index}
                                                    className="px-4 py-3 border-b border-gray-300 last:border-b-0 text-sm text-gray-700 bg-gray-200"
                                                >
                                                    {email}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                {/* Info Message */}
                                <div className="text-sm font-semibold text-gray-700 mb-6">
                                    After clicking the 'Start Assessment' button, you will be redirected to a new tab where your assessment will begin.
                                    Please complete it there. Once you're done, your detailed analytics report will be available in the 'Assessment Report' tab within 15 minutes.
                                </div>

                                {/* Navigation Buttons */}
                                <div className="flex items-center justify-between pt-4 max-md:flex-col w-full space-y-4">
                                    <button
                                        className="px-6 py-2 rounded-md text-sm font-medium transition bg-gray-200 text-gray-700 hover:bg-gray-300"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setCurrentStep((p) => p - 1);
                                        }}
                                    >
                                        Back
                                    </button>

                                    <button
                                        onClick={submit}
                                        disabled={loading}
                                        className={`flex items-center gap-2 px-6 py-2 rounded-md text-sm font-medium transition ${!loading
                                            ? "btn-gradient"
                                            : "bg-gray-300 text-gray-600 cursor-not-allowed"
                                            }`}
                                    >
                                        <IoMdSend />{loading ? "Starting..." : "Start Assessment"}
                                    </button>
                                </div>
                            </motion.div>
                        </div>
                    )}
                </motion.div>



                {/* <motion.div
                  className="bg-gray-100 border-l-4 border-yellow-400 px-6 py-3 mt-8 max-md:mt-2 max-md:mx-4"
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, ease: "easeOut" }}
                >
                  <p className="text-base text-gray-800 font-semibold text-center">
                    ⚠️ Note: 1 credit will be charged per assessee email
                  </p>
                </motion.div> */}
            </div>

            {showPopup && <AssessmentRedirectPopup
                url={redirectUrl}
                onClose={handleClosePopup}
            />}
        </div>
    )
}

export default IndividualAssessment